var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import acceptInvitation from '../../requests/authentication/acceptInvitation';
import Session from '../../services/Session';
import History from '../../services/History';
import Routes from '../../routes/RoutesConfig';
import GetCurrentUserCommand from '../users/GetCurrentUserCommand';
import Signals from '../../signals/Signals';
/**
 *
 */
var AcceptInvitationCommand = /** @class */ (function (_super) {
    __extends(AcceptInvitationCommand, _super);
    function AcceptInvitationCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param data
     * @param intl
     */
    AcceptInvitationCommand.prototype.execute = function (data, intl) {
        this.intl = intl;
        //
        var promise = acceptInvitation(data);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    AcceptInvitationCommand.prototype.then = function (response) {
        Session.setJWT(response.jwt);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.acceptinvitation.accepted' }), 'dark');
        var command = new GetCurrentUserCommand();
        command.execute().then(function () {
            if (Session.user.requiresOnBoarding) {
                History.push(Routes.ON_BOARDING.path);
            }
            else {
                History.push(Routes.ASSETS.path);
            }
        });
    };
    AcceptInvitationCommand.prototype.catch = function (error) {
    };
    return AcceptInvitationCommand;
}(Command));
export default AcceptInvitationCommand;
